// Vendored from emporiaenergy/qa-vocabulary v0.4.0 (internal repo, so the release tarball
// is not anonymously installable and the web build cannot `npm install` it). Refresh with:
//   gh release download v0.4.0 -R emporiaenergy/qa-vocabulary -p vocabulary.generated.ts \
//     -O web/src/vocabulary.generated.ts
// Keep the pinned version in step with the Python dependency in pyproject.toml.
//
// Generated by qa-vocabulary — DO NOT EDIT. Source: vocabulary.yaml v0.4.0 (activated 2026-10-30).
// Mechanical emission; never hand-maintained. Full metadata is vocabulary.json.

export const VOCABULARY_VERSION = "0.4.0";

export const INTERFACE_DEVICE_VALUES = [
  "ios",
  "android",
  "macos-chrome",
  "windows-chrome",
  "linux-chrome",
  "local-browser",
] as const;
export type InterfaceDeviceValue = (typeof INTERFACE_DEVICE_VALUES)[number];

export const EXPANSION_STRATEGY_VALUES = [
  "all",
  "pairwise",
  "rotate",
  "pinned",
] as const;
export type ExpansionStrategyValue = (typeof EXPANSION_STRATEGY_VALUES)[number];

export const PARAMETER_VALUES = [
  "interface_device",
  "account_type",
  "sign_in_method",
  "emporia_environment",
  "device_time_zone",
  "device_kind",
  "internal_ring",
] as const;
export type ParameterValue = (typeof PARAMETER_VALUES)[number];

export const SIDE_EFFECT_CLASS_VALUES = [
  "none",
  "reversible",
  "ends_session",
  "destructive",
] as const;
export type SideEffectClassValue = (typeof SIDE_EFFECT_CLASS_VALUES)[number];

export const EXECUTOR_KIND_VALUES = [
  "agent",
  "human",
] as const;
export type ExecutorKindValue = (typeof EXECUTOR_KIND_VALUES)[number];

export const ACTUATION_VALUES = [
  "virtual",
  "physical",
  "human",
] as const;
export type ActuationValue = (typeof ACTUATION_VALUES)[number];

export const RUN_KIND_VALUES = [
  "full_regression",
  "pr_set",
  "targeted",
] as const;
export type RunKindValue = (typeof RUN_KIND_VALUES)[number];

export const PROBE_REASON_VALUES = [
  "repeat",
  "isolate",
  "neighbor_interface",
  "neighbor_specs",
  "human",
] as const;
export type ProbeReasonValue = (typeof PROBE_REASON_VALUES)[number];

export const PROBE_CLASSIFICATION_VALUES = [
  "flake",
  "order_dependent",
  "client_regression",
  "cross_interface_device",
  "feature_wide",
  "environment",
  "stale_spec",
] as const;
export type ProbeClassificationValue = (typeof PROBE_CLASSIFICATION_VALUES)[number];

export const PHYSICAL_ACTION_VALUES = [
  "plug_vehicle",
  "unplug_vehicle",
  "bluetooth_nearby",
  "wifi_provision",
  "j1772_sim_mode",
] as const;
export type PhysicalActionValue = (typeof PHYSICAL_ACTION_VALUES)[number];

export const TIER_VALUES = [
  "smoke",
  "core",
  "extended",
] as const;
export type TierValue = (typeof TIER_VALUES)[number];

export const SET_KIND_VALUES = [
  "session",
  "state",
  "mixed",
] as const;
export type SetKindValue = (typeof SET_KIND_VALUES)[number];

export const OUTCOME_VALUES = [
  "pass",
  "fail",
  "error",
  "flake",
  "skipped",
] as const;
export type OutcomeValue = (typeof OUTCOME_VALUES)[number];

export const VERDICT_VALUES = [
  "confirmed",
  "real_regression",
  "intended_change",
  "flake",
  "spec_stale",
] as const;
export type VerdictValue = (typeof VERDICT_VALUES)[number];

export const CASE_STATUS_VALUES = [
  "planned",
  "generating",
  "covered",
  "partial",
  "uncovered",
  "blocked",
] as const;
export type CaseStatusValue = (typeof CASE_STATUS_VALUES)[number];

export const RUN_STATUS_VALUES = [
  "planning",
  "executing",
  "reducing",
  "complete",
  "aborted",
  "orphaned",
] as const;
export type RunStatusValue = (typeof RUN_STATUS_VALUES)[number];

export const GO_NO_GO_VALUES = [
  "go",
  "no_go",
] as const;
export type GoNoGoValue = (typeof GO_NO_GO_VALUES)[number];

export const EMPORIA_ENVIRONMENT_VALUES = [
  "prod",
  "dev3",
] as const;
export type EmporiaEnvironmentValue = (typeof EMPORIA_ENVIRONMENT_VALUES)[number];

export const EXPLORATION_MODE_VALUES = [
  "none",
  "scoped",
  "broad",
] as const;
export type ExplorationModeValue = (typeof EXPLORATION_MODE_VALUES)[number];

export const EXECUTION_MODE_VALUES = [
  "test",
  "observe",
] as const;
export type ExecutionModeValue = (typeof EXECUTION_MODE_VALUES)[number];

export const EXECUTION_STATUS_VALUES = [
  "pending",
  "running",
  "completed",
  "failed",
  "cancelled",
  "yielded",
] as const;
export type ExecutionStatusValue = (typeof EXECUTION_STATUS_VALUES)[number];

export const CASE_TARGET_VALUES = [
  "browser",
  "mobile",
] as const;
export type CaseTargetValue = (typeof CASE_TARGET_VALUES)[number];

export const TERMINAL_REASON_VALUES = [
  "cancelled",
  "failed",
  "timed_out",
  "superseded",
] as const;
export type TerminalReasonValue = (typeof TERMINAL_REASON_VALUES)[number];

export const SITTING_OUTCOME_VALUES = [
  "pass",
  "fail",
  "blocked",
] as const;
export type SittingOutcomeValue = (typeof SITTING_OUTCOME_VALUES)[number];

export const SPEC_BASIS_VALUES = [
  "observed",
  "reported",
  "maintenance",
  "unknown",
] as const;
export type SpecBasisValue = (typeof SPEC_BASIS_VALUES)[number];

export const VALUES = {
  "interface_device": INTERFACE_DEVICE_VALUES,
  "expansion_strategy": EXPANSION_STRATEGY_VALUES,
  "parameter": PARAMETER_VALUES,
  "side_effect_class": SIDE_EFFECT_CLASS_VALUES,
  "executor_kind": EXECUTOR_KIND_VALUES,
  "actuation": ACTUATION_VALUES,
  "run_kind": RUN_KIND_VALUES,
  "probe_reason": PROBE_REASON_VALUES,
  "probe_classification": PROBE_CLASSIFICATION_VALUES,
  "physical_action": PHYSICAL_ACTION_VALUES,
  "tier": TIER_VALUES,
  "set_kind": SET_KIND_VALUES,
  "outcome": OUTCOME_VALUES,
  "verdict": VERDICT_VALUES,
  "case_status": CASE_STATUS_VALUES,
  "run_status": RUN_STATUS_VALUES,
  "go_no_go": GO_NO_GO_VALUES,
  "emporia_environment": EMPORIA_ENVIRONMENT_VALUES,
  "exploration_mode": EXPLORATION_MODE_VALUES,
  "execution_mode": EXECUTION_MODE_VALUES,
  "execution_status": EXECUTION_STATUS_VALUES,
  "case_target": CASE_TARGET_VALUES,
  "terminal_reason": TERMINAL_REASON_VALUES,
  "sitting_outcome": SITTING_OUTCOME_VALUES,
  "spec_basis": SPEC_BASIS_VALUES,
} as const;

// vocabulary name -> value -> display label
export const LABELS: Record<string, Record<string, string>> = {
  "interface_device": {
    "ios": "iOS",
    "android": "Android",
    "macos-chrome": "macOS Chrome",
    "windows-chrome": "Windows Chrome",
    "linux-chrome": "Linux Chrome",
    "local-browser": "Local browser",
  },
  "expansion_strategy": {
    "all": "All",
    "pairwise": "Pairwise",
    "rotate": "Rotate",
    "pinned": "Pinned",
  },
  "parameter": {
    "interface_device": "Interface device",
    "account_type": "Account type",
    "sign_in_method": "Sign-in method",
    "emporia_environment": "Emporia environment",
    "device_time_zone": "Device time zone",
    "device_kind": "Device kind",
    "internal_ring": "Internal-ring cohort",
  },
  "side_effect_class": {
    "none": "None",
    "reversible": "Reversible",
    "ends_session": "Ends session",
    "destructive": "Destructive",
  },
  "executor_kind": {
    "agent": "Agent",
    "human": "Human",
  },
  "actuation": {
    "virtual": "Virtual",
    "physical": "Physical",
    "human": "Human",
  },
  "run_kind": {
    "full_regression": "Full regression",
    "pr_set": "PR set",
    "targeted": "Targeted",
  },
  "probe_reason": {
    "repeat": "Repeat",
    "isolate": "Isolate",
    "neighbor_interface": "Neighbor interface devices",
    "neighbor_specs": "Neighbor specs",
    "human": "Human",
  },
  "probe_classification": {
    "flake": "Flake",
    "order_dependent": "Order-dependent",
    "client_regression": "Client regression",
    "cross_interface_device": "Cross-interface-device regression",
    "feature_wide": "Feature-wide breakage",
    "environment": "Environment problem",
    "stale_spec": "Stale spec",
  },
  "physical_action": {
    "plug_vehicle": "Plug the vehicle in",
    "unplug_vehicle": "Unplug the vehicle",
    "bluetooth_nearby": "Bring the phone near the device",
    "wifi_provision": "Provision Wi-Fi",
    "j1772_sim_mode": "Put the J1772 simulator in a fault mode",
  },
  "tier": {
    "smoke": "Smoke",
    "core": "Core",
    "extended": "Extended",
  },
  "set_kind": {
    "session": "Session",
    "state": "State",
    "mixed": "Mixed",
  },
  "outcome": {
    "pass": "Pass",
    "fail": "Fail",
    "error": "Error",
    "flake": "Flake",
    "skipped": "Skipped",
  },
  "verdict": {
    "confirmed": "Confirmed",
    "real_regression": "Real regression",
    "intended_change": "Intended change",
    "flake": "Flake",
    "spec_stale": "Stale spec",
  },
  "case_status": {
    "planned": "Planned",
    "generating": "Generating",
    "covered": "Covered",
    "partial": "Partial",
    "uncovered": "Uncovered",
    "blocked": "Blocked",
  },
  "run_status": {
    "planning": "Planning",
    "executing": "Executing",
    "reducing": "Reducing",
    "complete": "Complete",
    "aborted": "Aborted",
    "orphaned": "Orphaned",
  },
  "go_no_go": {
    "go": "Go",
    "no_go": "No-go",
  },
  "emporia_environment": {
    "prod": "Production",
    "dev3": "Dev3",
  },
  "exploration_mode": {
    "none": "None",
    "scoped": "Scoped",
    "broad": "Broad",
  },
  "execution_mode": {
    "test": "Test",
    "observe": "Observe",
  },
  "execution_status": {
    "pending": "Pending",
    "running": "Running",
    "completed": "Completed",
    "failed": "Failed",
    "cancelled": "Cancelled",
    "yielded": "Yielded",
  },
  "case_target": {
    "browser": "Browser",
    "mobile": "Mobile",
  },
  "terminal_reason": {
    "cancelled": "Cancelled",
    "failed": "Failed",
    "timed_out": "Timed out",
    "superseded": "Superseded",
  },
  "sitting_outcome": {
    "pass": "Pass",
    "fail": "Fail",
    "blocked": "Blocked",
  },
  "spec_basis": {
    "observed": "Observed",
    "reported": "Reported",
    "maintenance": "Maintenance",
    "unknown": "Unknown",
  },
};

// glossary concept slugs, in authored order
export const GLOSSARY_SLUGS = [
  "spec_section",
  "parameter",
  "parameter_value",
  "attribute",
  "emporia_environment",
  "case",
  "suite",
  "run",
  "run_kind",
  "test_set",
  "policy",
  "scenario",
  "attempt",
  "delivery",
  "outcome",
  "verdict",
  "case_status",
  "go_no_go",
  "probe",
  "execution",
  "sitting",
  "fixture",
  "interface_device",
  "emporia_device",
  "report",
  "finding",
  "triage",
] as const;
export type GlossarySlug = (typeof GLOSSARY_SLUGS)[number];

// reserved/retired words, in authored order
export const RESERVED_TERMS = [
  "Test run",
  "MC run",
  "mesh run",
  "Variable",
  "Case variable",
  "Configuration",
  "Platform",
  "Run",
  "Environment",
  "Attempt",
  "Scenario",
  "Regression",
  "Test",
  "Evaluation",
] as const;
